<section
  class="cms-full-width-booking-widget relative"
  [class.framed-hero]="enableBackgroundImage()"
  [class.overflow-hidden]="isNewBrand()"
  [class.grid-max-width]="isNewBrand()"
  [class.grid-col-12]="isNewBrand()"
  [class.no-row-gap]="isNewBrand()"
  [class.has-background-image]="enableBackgroundImage()"
>
  @if (enableBackgroundImage()) {
    <fin-content-image
      class="background-image"
      [imageData$]="backgroundImage() | finToObservable"
      [aspectRatio$]="aspectRatio() | finToObservable"
      [isLazyLoad]="false"
      [fetchPriority]="FetchPriorityEnum.high"
    />
  }
  <div
    class="grid-max-width"
    [class.framed-hero-content]="enableBackgroundImage()"
    [class.grid-col-12]="!isNewBrand()"
    [class.bg-container]="!isNewBrand()"
    [class.col-1-12]="isNewBrand()"
  >
    <div [class.col-1-12]="!isNewBrand()" [class.mr-xlarge-y]="!isNewBrand()">
      <fin-booking-widget
        [enableAward]="enableAward()"
        [enableAurinkomatkat]="enableAurinkomatkat()"
        [enablePromoCode]="enablePromoCode()"
        [defaultLocations]="defaultLocationPairs()"
        [initialTripType]="initialTripType()"
        [enableFlightTab]="enableFlightTab()"
        [enableHotelsTab]="enableHotelsTab()"
        [enableCarRentalTab]="enableCarRentalTab()"
        [bordered]="!enableBackgroundImage()"
        [headingLevel]="2"
        [compactMode]="isNewBrand()"
        [headingEnabled]="headingEnabled()"
      />
    </div>
  </div>
</section>
